export const userid = (id) =>{
    return {
        type:'USERID',
        payload:id
    };
};